// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.first-contact-permissions-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.first-contact-permissions-page .settings-modal-header {
  position: relative;
  justify-content: center;
}

.first-contact-permissions-page .back-button {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.first-contact-permissions-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.permissions-section {
  margin-bottom: 32px;
}

.permissions-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.permissions-section-note {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
}

/* Default Permissions Radio Group */
.permissions-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding-left: 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.radio-option:hover {
  background-color: #f5f5f5;
}

.radio-option input[type="radio"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--netsfere-red);
}

.radio-label {
  font-size: 15px;
  color: #333;
  cursor: pointer;
  user-select: none;
}

/* Exception Input Group */
.exception-input-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.exception-input {
  width: 100%;
  padding: 12px 16px;
  font-size: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.exception-input:focus {
  border-color: var(--netsfere-red);
}

.exception-input::placeholder {
  color: #999;
}

.add-exception-button {
  align-self: flex-end;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background-color: var(--netsfere-red);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.add-exception-button:hover:not(:disabled) {
  background-color: #b82419;
}

.add-exception-button:disabled {
  background-color: #ed9a9a;
  cursor: not-allowed;
}

/* Input validation error state */
.exception-input.input-error {
  border-color: #d92d20;
}

.exception-input.input-error:focus {
  border-color: #d92d20;
}

.exception-error-message {
  color: #d92d20;
  font-size: 13px;
  margin-top: 4px;
  padding-left: 4px;
}

/* Blocked List Table */
.empty-blocked-list {
  padding: 32px;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.empty-blocked-list-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.empty-blocked-list-message {
  color: #999;
  font-size: 14px;
}

.blocked-list-table {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.blocked-list-table table {
  width: 100%;
  border-collapse: collapse;
}

.blocked-list-table thead {
  background-color: #f5f5f5;
}

.blocked-list-table th {
  padding: 0;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #666;
  border-bottom: 1px solid #e0e0e0;
}

.table-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
}

.table-header-content span {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.table-header-content .clear-all-button {
  margin-left: auto;
}

.clear-all-button {
  padding: 6px 12px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #d92d20;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.clear-all-button:hover {
  background-color: #ffe5e5;
}

.blocked-list-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s ease;
}

.blocked-list-table tbody tr:last-child {
  border-bottom: none;
}

.blocked-list-table tbody tr:hover {
  background-color: #f9f9f9;
}

.blocked-list-table td {
  padding: 12px;
  font-size: 14px;
  vertical-align: middle;
}

.type-badge {
  display: inline-block;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 12px;
  text-transform: capitalize;
}

.type-badge.user {
  background-color: #e3f2fd;
  color: #1976d2;
}

.type-badge.domain {
  background-color: #f3e5f5;
  color: #7b1fa2;
}

.value-cell {
  font-family: 'Courier New', monospace;
  color: #555;
}

.remove-button {
  padding: 6px 12px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: var(--netsfere-red);
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  float: right;
}

.remove-button:hover {
  background-color: #ffe5e5;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .first-contact-permissions-content {
    padding: 16px;
  }

  .blocked-list-table {
    overflow-x: auto;
  }

  .blocked-list-table table {
    min-width: 500px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/FirstContactPermissionsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".first-contact-permissions-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.first-contact-permissions-page .settings-modal-header {\n  position: relative;\n  justify-content: center;\n}\n\n.first-contact-permissions-page .back-button {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.first-contact-permissions-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.permissions-section {\n  margin-bottom: 32px;\n}\n\n.permissions-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.permissions-section-note {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 12px;\n}\n\n/* Default Permissions Radio Group */\n.permissions-radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding-left: 12px;\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n}\n\n.radio-option:hover {\n  background-color: #f5f5f5;\n}\n\n.radio-option input[type=\"radio\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--netsfere-red);\n}\n\n.radio-label {\n  font-size: 15px;\n  color: #333;\n  cursor: pointer;\n  user-select: none;\n}\n\n/* Exception Input Group */\n.exception-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.exception-input {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 14px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.exception-input:focus {\n  border-color: var(--netsfere-red);\n}\n\n.exception-input::placeholder {\n  color: #999;\n}\n\n.add-exception-button {\n  align-self: flex-end;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  background-color: var(--netsfere-red);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.add-exception-button:hover:not(:disabled) {\n  background-color: #b82419;\n}\n\n.add-exception-button:disabled {\n  background-color: #ed9a9a;\n  cursor: not-allowed;\n}\n\n/* Input validation error state */\n.exception-input.input-error {\n  border-color: #d92d20;\n}\n\n.exception-input.input-error:focus {\n  border-color: #d92d20;\n}\n\n.exception-error-message {\n  color: #d92d20;\n  font-size: 13px;\n  margin-top: 4px;\n  padding-left: 4px;\n}\n\n/* Blocked List Table */\n.empty-blocked-list {\n  padding: 32px;\n  text-align: center;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.empty-blocked-list-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.empty-blocked-list-message {\n  color: #999;\n  font-size: 14px;\n}\n\n.blocked-list-table {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.blocked-list-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.blocked-list-table thead {\n  background-color: #f5f5f5;\n}\n\n.blocked-list-table th {\n  padding: 0;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #666;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.table-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n}\n\n.table-header-content span {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.table-header-content .clear-all-button {\n  margin-left: auto;\n}\n\n.clear-all-button {\n  padding: 6px 12px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  color: #d92d20;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.clear-all-button:hover {\n  background-color: #ffe5e5;\n}\n\n.blocked-list-table tbody tr {\n  border-bottom: 1px solid #e0e0e0;\n  transition: background-color 0.2s ease;\n}\n\n.blocked-list-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.blocked-list-table tbody tr:hover {\n  background-color: #f9f9f9;\n}\n\n.blocked-list-table td {\n  padding: 12px;\n  font-size: 14px;\n  vertical-align: middle;\n}\n\n.type-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 12px;\n  text-transform: capitalize;\n}\n\n.type-badge.user {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.type-badge.domain {\n  background-color: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.value-cell {\n  font-family: 'Courier New', monospace;\n  color: #555;\n}\n\n.remove-button {\n  padding: 6px 12px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--netsfere-red);\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n  float: right;\n}\n\n.remove-button:hover {\n  background-color: #ffe5e5;\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .first-contact-permissions-content {\n    padding: 16px;\n  }\n\n  .blocked-list-table {\n    overflow-x: auto;\n  }\n\n  .blocked-list-table table {\n    min-width: 500px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
